export default __webpack_public_path__ + "static/media/dioni-pink1.a441cb43.jpg";